module.exports = __webpack_public_path__ + "img/Löschzug_Freiwillige_Feuerwehr.0e1e9fc5.svg";